<script lang="ts" setup>
import type { Testimonials } from '~~/server/api/insurance/assistance-services'
// @ts-ignore
import { SplideSlide } from '@splidejs/vue-splide'

export interface PagesAssistanceServicesTesimonialsProps {
    data: Testimonials
}

const props = defineProps<PagesAssistanceServicesTesimonialsProps>()

const sliderOptions = {
    pagination: true,
    arrows: true,
    gap: '3rem',
    drag: true,
    perPage: 2,
    breakpoints: {
        992: {
            drag: true,
            pagination: true,
            gap: '2rem',
            arrows: true,
        },
        768: {
            fixedWidth: '90%',
            perPage: 1,
            gap: '1rem',
        },
    },
}
</script>

<template>
  <section class="scroll-margin-top-10">
    <Tracker :data="{ position: props.data.title }">
      <BoxHeader
        :heading="props.data.title"
        heading-level="h2"
      />

      <Slider :options="sliderOptions">
        <SplideSlide
          v-for="(testimonial, index) in props.data.data"
          :key="`astest-${index}`"
          class="translate-y-hover-wrapper"
        >
          <PagesAssistenceServicesTestimonialsItem
            :testimonial="testimonial"
          />
        </SplideSlide>
      </Slider>
    </Tracker>
  </section>
</template>
